import { render, staticRenderFns } from "./CompanyHome.vue?vue&type=template&id=2880d72f&scoped=true&"
import script from "./CompanyHome.vue?vue&type=script&lang=js&"
export * from "./CompanyHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880d72f",
  null
  
)

export default component.exports